import React from 'react';

interface VismaLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const VismaLogo: React.FC<VismaLogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <svg
        viewBox="0 0 100 30"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* White background */}
        <rect
          x="0"
          y="0"
          width="100"
          height="30"
          fill="#ffffff"
        />
        
        {/* Red V-shaped graphic - stylized checkmark/V */}
        <path
          d="M 3 25 L 8 5 L 13 25 L 18 5 L 23 25"
          stroke="#dc2626"
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* Thickened rounded end */}
        <circle cx="23" cy="25" r="2" fill="#dc2626"/>
        
        {/* VISMA text */}
        <text
          x="30"
          y="20"
          fontSize="14"
          fontWeight="bold"
          fill="#000000"
          fontFamily="Arial, sans-serif"
        >
          VISMA
        </text>
      </svg>
    </div>
  );
};

export default VismaLogo;
